import styled from 'styled-components';

export const IntegrationsTabsContainer = styled.div`
  .nav > li > a {
    padding: 10px;
  }
`;
